<template>
  <div id="app">
<!--
    <GenericModal
      v-bind:show="showModal"
      v-on:close="onGenericModalClose"
      v-bind:hideCloseMobile="modalProps.hideCloseMobile"
      v-bind:fullHeightMobile="modalProps.fullHeightMobile">

      <component
        ref="generic-slot-component"
        v-bind:is="modalContentComponent"
        v-bind:modalProps="modalProps"
        v-bind:successCallback="modalSuccessCallback">
      </component>
    </GenericModal>

    <DropNotification></DropNotification>

    <div v-if="globalError" class="global-error alert-danger">
      <div class="error-container">
        <span v-if="!hideDefaultMessage"> There was a problem processing your request. We apologize for the inconvenience.</span>
        <span class="error-message"><b>Error:</b> {{globalError}}</span>
        <i v-on:click="clearError" class="fa fa-close clear-error"></i>
      </div>
    </div>

    <template v-if="isSettingCurrentUser">
      <BlankNavbar></BlankNavbar>
    </template>

    <template v-else-if="currentUser">
      <Navbar></Navbar>
    </template>

    <template v-else>
      <MainNavbar></MainNavbar>
    </template> -->

    <div class="container-fluid" v-bind:class="{ retractPadding : isRetractPaddingRoute }">
      <router-view></router-view>
    </div>
<!--
    <template v-if="!currentUser && !isSettingCurrentUser && !hideFooterRoutes">
      <Foot></Foot>
    </template>

    <div v-if="showPwaDownloadPrompt" class="pwa-download-prompt">
      <div class="pwa-container">
        Install this app on your device! Tap the share button and then click "Add to Home Screen."
        <span class="arrow-down"></span>
        <img v-on:click="hidePwaDownloadPrompt()" class="close-pwa" src="@/assets/images/icons/close-x-white.svg">
      </div>
    </div> -->

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import EventBus from '@/components/utilities/EventBus'
import Navbar from '@/components/Navbar'
import BlankNavbar from '@/components/BlankNavbar'
import MainNavbar from '@/components/MainNavbar'
import Foot from '@/components/Foot'
import GenericModal from '@/components/modals/GenericModal'
import ShareProduct from '@/components/share/ShareProduct'
import ProductLinkDetails from '@/components/product-link/ProductLinkDetails'
import BxCarousel from '@/components/BxCarousel'
import DropNotification from '@/components/utilities/DropNotification'
import store from './store'

export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Beauty Scripts',
    // all titles will be injected into this template
    titleTemplate: '%s | Beauty Scripts'
  },
  components: {
    Navbar,
    BlankNavbar,
    Foot,
    GenericModal,
    ShareProduct,
    BxCarousel,
    DropNotification,
    ProductLinkDetails,
    MainNavbar
  },
  data () {
    return {
      showModal:                false,
      modalContentComponent:    null,
      modalProps:               {},
      modalSuccessCallback:     () => {}
    }
  },
  mounted () {
    // NOTE: To display a modal from another component, pass the component
    // name to the EventBus as 'modalContentComponent'. Any modal you will be
    // displaying has to be registered here in App.vue
    EventBus.$on('showModal', (payload) => {
      this.modalContentComponent = payload.modalContentComponent
      this.modalSuccessCallback  = payload.modalSuccessCallback
      this.modalProps            = payload.modalProps
      this.showModal             = true
    })
    EventBus.$on('hideModal', () => {
      this.showModal             = false
    })
  },
  created () {
    this.showPrompt()
    this.setIsMobileDevice()
    store.dispatch('getScriptCategories')
    store.dispatch('getProfessions')
  },
  computed: {
    ...mapGetters({
      currentUser:            'currentUser',
      currentPro:             'currentPro',
      globalError:            'errorMessage',
      hideDefaultMessage:     'hideDefault',
      showPwaDownloadPrompt:  'showPwaDownloadPrompt',
      isSettingCurrentUser:   'isSettingCurrentUser'
    }),
    isRetractPaddingRoute () {
      return this.$route.path === '/'
    },
    isConsumerView () {
      return Object.keys(this.currentPro).length > 0
    },
    hideFooterRoutes () {
      return this.$route.path === '/login'
    }
  },
  methods: {
    clearError () {
      store.dispatch('removeError')
    },
    hidePwaDownloadPrompt () {
      store.dispatch('disablePwaDownloadPrompt')
    },
    showPrompt () {
      // Detects if device is on iOS
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase()
        return /iphone|ipad|ipod/.test(userAgent)
      }
      // Detects if device is in standalone mode
      const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone)

      // Checks if should display install popup notification:
      if (isIos() && !isInStandaloneMode()) {
        store.dispatch('enablePwaDownloadPrompt')
      }
    },
    setIsMobileDevice () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        store.dispatch('setIsMobileDevice')
      }
    },
    onGenericModalClose () {
      this.showModal = false
      if (this.$refs['generic-slot-component'] && this.$refs['generic-slot-component'].modalCloseCallback) {
        this.$refs['generic-slot-component'].modalCloseCallback()
      }
    }
  }
}
</script>

<style lang="scss">

html {
  height:                 100%; /* make sure it is at least as tall as the viewport */
  position:               relative;
}

body {
  font-family:            'ProximaNovaLight', 'sans-serif';
  height:                 100%;
  overflow-x:             hidden;
  letter-spacing:         0.05em;
}

h1, h2, h3, h4, h5, h6 {
  font-family:            'Bodoni';
  letter-spacing:         0.02em;
}

.sub-header-1 {
  font-family:            'Bodoni';
  letter-spacing:         0.02em;
}

.global-error {
  padding:                1em 2.5em;
  text-align:             center;
  position:               fixed;
  top:                    0;
  left:                   0;
  right:                  0;
  z-index:                999999;

  .error-container {

    .error-message {
      display:            block;
      margin-top:         1em;
    }

    .clear-error {
      position:           absolute;
      top:                25%;
      right:              0.5em;
      font-size:          2em;
      cursor:             pointer;
    }
  }
}

#app {
  min-height:             100%;

  .container-fluid {
    padding:              0;
    height:               100%;
    min-height:           30em;
    padding-top:          3.6em;

    &.retractPadding {
      padding-top:        0;
    }
  }

  .pwa-download-prompt {
    display:              inline-block;
    position:             fixed;
    bottom:               0;
    margin:               1em 2em;
    box-shadow:           0 2px 6px 0 rgba(0,0,0,.4);
    background-color:     black;
    border-radius:        0.5em;
    color:                white;

    .pwa-container {
      position:           relative;
      padding:            1em 2em;

      .close-pwa {
        height:           1em;
        width:            1em;
        position:         absolute;
        top:              0.8em;
        right:            0.8em;
      }

      .arrow-down {
        display:            block;
        position:           absolute;
        content:            "";
        width:              1em;
        height:             1em;
        right:              45%;
        bottom:             -6px;
        background-color:   black;
        -webkit-transform:  translateX(-6px) rotate(45deg);
        transform:          translateX(-6px) rotate(45deg);
        pointer-events:     none;
        -webkit-box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.2);
        box-shadow:         2px 2px 2px 0 rgba(0, 0, 0, 0.2)
      }
    }
  }

}


@font-face {
  font-family: TheanoDidot;
  src: url('./assets/fonts/TheanoDidotRegular.ttf');
}

@font-face {
  font-family: ProximaNova;
  src: url('./assets/fonts/ProximaNova-Regular.otf');
}

@font-face {
  font-family: ProximaNovaLight;
  src: url('./assets/fonts/ProximaNovaLight.otf');
}

@font-face {
  font-family: Bodoni;
  src: url('./assets/fonts/BodoniRoman.ttf');
}

@font-face {
  font-family: Jendral;
  src: url('./assets/fonts/JendralWritingLatinPro-Normal.otf');
}

/* Landscape phone to portrait tablet */
@media (max-width: 767px) {

  #app {
    .container-fluid {
      padding-top:        3.6em;
      height:             unset;
    }
  }

  input[type="text"],
  select:focus,
  textarea {
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue